"use client";
import React, { useEffect, useRef } from "react";
import Image from "next/image";
import { AddressProps } from ".";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ReachUs = ({ data }: AddressProps) => {
  const iconRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (data && iconRef.current) {
      const addressImg = iconRef.current.querySelectorAll(".addressImg");

      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      tl.fromTo(
        addressImg,
        { y: 150, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          ease: "slow(0.4, 0.4, false)",
          stagger: 0.2,
        }
      );

      ScrollTrigger.create({
        trigger: iconRef.current,
        start: "top 60%",
        end: "bottom 10%",
        animation: tl,

        onEnter: () => tl.play(),
        onLeaveBack: () => tl.reverse(),
        // markers: true
      });
    }
  }, [data]);

  return (
    <div
      ref={iconRef}
      className="container flex flex-col items-center px-4 mx-auto section-spacing"
    >
      <h1 className="text-[#032d60] font-semibold mb-5 sm:mb-10 text-center text-2xl sm:text-3xl lg:text-4xl">
        {data.headingAddress}
      </h1>
      <div className="flex flex-wrap justify-around gap-10 sm:gap-10 lg:gap-0 lg:w-3/4 ">
        {data.addresses.map((reachway: any, index: number) => {
          const imgurl = reachway?.icon?.data?.attributes?.url;
          return (
            <a
              target="_blank"
              href={reachway.href}
              key={index}
              className="flex flex-col items-center addressImg max-md:basis-1/2 max-sm:basis-full "
            >
              <div className="flex items-center justify-center rounded-full ">
                <div className="">
                  <Image
                    src={imgurl || ""}
                    alt={reachway.icon.data.attributes.name || "icon"}
                    width={52}
                    height={52}
                  />
                </div>
              </div>
              <p className="mt-3 text-md text-[#032d60] font-medium">
                {reachway.title}
              </p>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ReachUs;
